import React from "react";
import { Trans } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { collapsedSidebarState } from "../../atoms";
import { useRecoilState } from "recoil";
import { useUserContext } from "hooks";
import { check_permissions } from 'Helpers'
import { UncontrolledCollapse } from "reactstrap";


const LiItemDropdown = (props) => {
    // const [showSidebar2, setShowSidebar2] = useRecoilState(showSidebar2State);
    const location = useLocation();
    const [showMenu, setShowMenu] = React.useState(false);

    const [refresh, setRefresh] = React.useState(true)

    const [currentActive, setCurrentActive] = React.useState(false);

    const [collapsedSidebar, setCollapsedSidebar] = useRecoilState(collapsedSidebarState);
    const { permissions } = useUserContext();


    React.useEffect(() => {
        setRefresh(!refresh)
    }, [location]);


    const handlemouseLeavingChildList = () => {
        if (collapsedSidebar === true) {
            setShowMenu(false)
        }
    }
    React.useEffect(() => {

        if (showMenu === true) {
            setCurrentActive(true)
        } else {
            setCurrentActive(false)
        }
    }, [showMenu])

    React.useEffect(() => {
        if (collapsedSidebar === true) {
            setShowMenu(false)
        }
    }, [collapsedSidebar])


    return (
        check_permissions(permissions, props.access, props.func)?
        <div>
            {
                props.childList.length > 0 ? <div className={`parent wrapper-menu-item ${collapsedSidebar === true ? "wrapper-menu-item-fix-collapse" : ""}`}
                    onClick={() => { setShowMenu(!showMenu) }}>
                    <div className="icon-ctn">
                        <span className={`ic ${props.icon}-icon ${currentActive === true ? "icon-active" : ""}`}></span>
                    </div>
                    {collapsedSidebar === false &&
                        <>
                            <div className="txt-ctn"><Trans>{props.text}</Trans></div>
                            <div className="chevron-ctn">
                                {props.dropdown === true &&
                                    <>
                                        {showMenu === true ?
                                            <span className="fa fa-chevron-down fa-fw" style={{ color: "#59627f" }} />
                                            :
                                            <span className="fa fa-chevron-right ar-rotate-180 fa-fw" style={{ color: "#59627f" }} />
                                        }
                                    </>
                                }
                            </div>
                        </>
                    }
                </div> :
                    <Link to={props.url} className={`parent wrapper-menu-item ${collapsedSidebar === true ? "wrapper-menu-item-fix-collapse" : ""}  ${(location.pathname + location.search).includes(props.url) ? "item-is-active" : ""}`}
                        onClick={() => { setShowMenu(!showMenu) }}>
                        <div className="icon-ctn">
                            <span className={`ic ${props.icon}-icon ${currentActive === true ? "icon-active" : ""}`}></span>
                        </div>
                        {collapsedSidebar === false &&
                            <>
                                <div className="txt-ctn"><Trans>{props.text}</Trans> {props?.isNew && (<span className="badge text-danger font-weight-bold"><Trans>NEW</Trans></span>)}</div>
                                <div className="chevron-ctn">
                                    {props.dropdown === true &&
                                        <>
                                            {showMenu === true ?
                                                <span className="fa fa-chevron-down fa-fw" style={{ color: "#59627f" }} />
                                                :
                                                <span className="fa fa-chevron-right fa-fw" style={{ color: "#59627f" }} />
                                            }
                                        </>
                                    }

                                </div>
                            </>
                        }
                    </Link>
            }
            {props.childList &&
                <div className={`${showMenu ? "d-block" : "d-none"}`}>
                    {props.childList.map((item, key) => (
                        check_permissions(permissions, item.access, item.func) &&
                        <React.Fragment key={key}>
                            {item.subChildList ?
                                <div className="wrapper-menu-item fade-in-top d-block toggler-parent" key={key}>
                                    <div className={`icon-ctn ${item.sub_children ? 'font-weight-bold' : ''}`}></div>
                                    <button className="toggler btn btn-link shadow-none pl-4 sub-menu w-100 text-left mx-0 txt-ctn" id={`toggler-${key}`} data-toggle="collapse" >
                                        <Trans>{item.text}</Trans> {/*Sub Menu */}
                                    </button>
                                    <UncontrolledCollapse toggler={`#toggler-${key}`}>
                                        {item.subChildList.map((item, key2) => {
                                            return (
                                                check_permissions(permissions, item.access, item.func) &&
                                                <div className={`pl-4 sub-menu wrapper-menu-item fade-in-top ${(location.pathname + location.search).includes(item.url) ? "item-is-active" : ""}`} key={key2}>
                                                    <Link to={item.url} className="txt-ctn" key={key2}>
                                                        <Trans>{item.text}</Trans>
                                                    </Link>
                                                </div>
                                            )
                                        })}
                                    </UncontrolledCollapse>
                                </div>
                                :
                                <div className={`wrapper-menu-item sub-menu fade-in-top ${(location.pathname + location.search).includes(item.url) ? "item-is-active" : ""}`} key={key}>
                                    <div className={`icon-ctn ${item.sub_children ? 'font-weight-bold' : ''}`}></div>
                                    <Link to={item.url} className={`txt-ctn ${item.sub_children ? 'font-weight-bold' : ''}`} >
                                        <Trans>{item.text}</Trans> {/*Menu Item */}
                                        {item?.isNew && (
                                            <span className="badge text-danger font-weight-bold">
                                                <Trans>NEW</Trans>
                                            </span>
                                        )}
                                    </Link>

                                </div>
                            }
                        </React.Fragment>
                    )
                    )}
                </div>
            }
        </div>
        :
        null
    );
};
export default LiItemDropdown;

